<template>
    <div>
        <div class="p-4">
            <div class="flex justify-between mb-3">
                <div class="flex">
                    <InputGroup placeholder="Title" v-model="title" class="mr-3" />
                    <SelectGroup v-model="status" :options="{all: 'All', ...getEventStatuses()}" class="mr-3" />
                    <ButtonSecondary @click="filterItem" class="mr-3">Filter</ButtonSecondary>
                </div>
                <div class="flex">
                    <ButtonPrimary @click="goToAddEventPage" class="mr-3">Add</ButtonPrimary>
                </div>
            </div>
            <div class="flex justify-end">
                Num of Records: {{ numOfRecords }}
            </div>
            <div class="relative overflow-x-auto rounded-xl border-2">
                <table class="w-full text-sm text-left text-gray-500 shadow-lg">
                    <thead class="text-xs text-gray-700 bg-primary">
                        <tr>
                            <th scope="col" class="px-6 py-3 select-none text-white" :class="sortable[index] ? 'cursor-pointer' : ''" v-for="(header, index) in headers" :key="header" @click="sortable[index] ? sortItem(fields[index]) : null">
                                <span class="inline-block text-sm font-bold">{{ header }}</span>
                                <span class="ml-2 inline-block" v-if="sortBy === fields[index]">
                                    <AscendingIcon v-if="sortOrder === 1" />
                                    <DescendingIcon v-if="sortOrder === -1" />
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-b" v-for="(item, index) in items" :key="item._id">
                            <td class="px-6 py-4" v-for="field in fields" :key="field">
                                <span v-if="field === 'action'">
                                    <ButtonPrimary class="mr-3" @click="goToVotingPage(item._id)"><InfoIcon /></ButtonPrimary>
                                    <ButtonAccent class="mr-3" @click="goToEditEventPage(item._id)"><EditIcon /></ButtonAccent>
                                    <ButtonDanger @click="deleteItem(index)"><DeleteIcon /></ButtonDanger>
                                </span>
                                <span v-else-if="field === 'status'" class="cursor-pointer">
                                    <span v-if="item[field] === 'ended'"
                                        class="bg-red-100 text-red-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-red-900 dark:text-red-300">Ended</span>
                                    <span v-else-if="item[field] === 'ready'"
                                        class="bg-green-100 text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">Ready</span>
                                    <span v-else-if="item[field] === 'not_ready'"
                                        class="bg-yellow-100 text-yellow-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300">Not Ready</span>
                                </span>
                                <span v-else-if="field === 'createdAt'">{{ formatDatetime(item[field]) }}</span>
                                <span v-else-if="field === 'exhibitors' || field === 'visitors'">
                                    {{ item[field] ? item[field].length : 0 }}
                                </span>
                                <span v-else>{{ item[field] }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {

    },

    data() {
        return {
            headers: ['', 'Title', 'Status', 'Created At', 'Exhibitors', 'Visitors'],
            fields: ['action', 'title', 'status', 'createdAt', 'exhibitors', 'visitors'],
            sortable: [false, true, true, true, false, false],
            items: [],

            // Filters
            title: '',
            status: 'all',
            sortBy: 'createdAt',
            sortOrder: 1,

            // Modals
            selectedImage: '',
            selectedUser: null,
            selectedStatus: null,
        };
    },

    async mounted() {
        await this.retrieveData();
    },

    methods: {
        async retrieveData() {
            const response = await this.httpRequest('/organizer/event', 'get', {
                params: {
                    title: this.title,
                    status: this.status !== 'all' ? this.status : undefined,
                    sortBy: this.sortBy,
                    sortOrder: this.sortOrder,
                }
            });
            if (response.result === 'success') {
                const items = response.data.events;
                this.items = JSON.parse(JSON.stringify(items).replace(/__host__/g, process.env.VUE_APP_API_URL));
            }
        },

        filterItem() {
            this.retrieveData();
        },

        sortItem(sortBy) {
            if (this.sortBy === sortBy) {
                this.sortOrder = this.sortOrder === -1 ? 1 : -1;
            } else {
                this.sortOrder = 1;
            }
            this.sortBy = sortBy;

            this.retrieveData();
        },

        goToAddEventPage() {
            this.$router.push(`/event/add`);
        },

        goToEditEventPage(id) {
            this.$router.push(`/event/${id}`);
        },

        goToVotingPage(id) {
            this.$router.push(`/event/${id}/voting`);
        },

        async deleteItem(index) {
            const item = this.items[index];
            const id = item._id;
            const title = item.title;

            const action = async () => {
                const response = await this.$root.organizer.deleteITShowcaseEvent(id);
                if (response.result === 'success') {
                    this.retrieveData();
                }
            };

            this.$root.showConfirm(`Confirm delete event "${title}"?`, action);
        },
    },

    computed: {
        numOfRecords() {
            return this.items.length;
        },
    }
}
</script>